<template>
  <el-select
    v-model="stateModel"
    :name="$t('COMMON.STATES')"
    :multiple="multiple"
    :filterable="filterable"
    @change="stateChanged"
  >
    <el-option
      v-for="state in states"
      :key="state[0]"
      :value="state[0]"
      :label="state[0]"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";
import { allCountries } from "country-region-data";

export default {
  name: "state-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    country: {
      type: String,
      default: null,
      description: "Country id",
    },
    state: {
      type: String,
      default: null,
      description: "State id",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
  },

  data() {
    const selectedCountry = allCountries.find((el) => el[0] === this.country);
    let states = [];
    if (selectedCountry) {
      states = selectedCountry[2];
    }
    return {
      stateModel: states.find((el) => el[0] === this.state) ? this.state : null,
      states: states,
    };
  },

  setup() {},

  created() {},

  methods: {
    stateChanged(state) {
      this.$emit("stateChanged", state);
    },
  },

  watch: {
    state(state) {
      this.stateModel = state;
    },
    country(country) {
      const selectedCountry = allCountries.find((el) => el[0] === country);
      if (selectedCountry) {
        this.states = selectedCountry[2];
        if (!this.states.find((el) => el[0] === this.state)) {
          this.stateModel = null;
        }
      }
    },
  },
};
</script>
